function g(t) {
  const m = {
    xxs: {
      gutter: "0.8rem",
      margin: "1.6rem",
      maxWidth: `${22.4375}rem`,
      minWidth: "0rem"
    },
    xs: {
      gutter: "0.8rem",
      margin: "1.6rem",
      maxWidth: `${23.375}rem`,
      minWidth: `${22.5}rem`
    },
    s: {
      gutter: "0.8rem",
      margin: "1.6rem",
      maxWidth: `${47.9375}rem`,
      minWidth: `${23.4375}rem`
    },
    m: {
      gutter: "1.2rem",
      margin: "2.4rem",
      maxWidth: `${63.9375}rem`,
      minWidth: "48rem"
    },
    l: {
      gutter: "1.2rem",
      margin: "2.4rem",
      maxWidth: `${89.9375}rem`,
      minWidth: "64rem"
    },
    xl: {
      gutter: "1.6rem",
      margin: "8rem",
      maxWidth: `${119.9375}rem`,
      minWidth: "90rem"
    },
    xxl: {
      gutter: "1.6rem",
      margin: "8rem",
      maxWidth: "",
      minWidth: "120rem"
    }
  }, d = Object.keys(m), e = typeof t != "object" ? [] : Object.keys(t).filter(
    (r) => d.includes(r)
  );
  return [(e == null ? void 0 : e.length) > 0, (r) => !(e != null && e.length) || typeof t != "object" ? "" : e.reduce((i, n) => {
    const s = t[n];
    if (!s) return i;
    const h = `
			@media screen and (min-width: ${m[n].minWidth}) {
				${r(s)}
			}`;
    return i + h;
  }, "")];
}
export {
  g as buildResponsiveSize
};
